export const PLAY_SONG_REQUEST = "PLAY_SONG_REQUEST";
export const PAUSE_SONG_REQUEST = "PAUSE_SONG_REQUEST";
export const PLAY_MASTER = "PLAY_MASTER";
export const PAUSE_MASTER = "PAUSE_MASTER";
